import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import Representatives from "@/components/legal/Representatives";
import CorporateDocuments from "@/components/legal/CorporateDocuments";
import RequirementTemplates from "@/components/legal/RequirementTemplates";
import Letterheads from "@/components/legal/Letterheads";
import Oficios from "@/components/legal/Oficios";
import CorporateProfile from "@/components/legal/CorporateProfile";

const TABS = [
  { id: "perfil", label: "Expediente Corporativo" },
  { id: "representantes", label: "Representantes Legales" },
  { id: "documentos", label: "Documentos" },
  { id: "oficios", label: "Oficios" },
  { id: "membretes", label: "Membretes" },
  { id: "plantillas", label: "Plantillas de Requisitos" },
];

export default function LegalRecords() {
  const [tab, setTab] = useState("perfil");
  const [summary, setSummary] = useState(null);

  const loadSummary = () => api.get("/legal/summary").then((r) => setSummary(r.data)).catch(() => {});
  useEffect(() => { loadSummary(); }, [tab]);

  return (
    <div data-testid="legal-records-page">
      <PageHeader title="Gestión Documental" subtitle="EXPEDIENTE JURÍDICO, REPRESENTANTES, DOCUMENTOS Y PLANTILLAS DE REQUISITOS" />
      <div className="px-6 lg:px-8 py-5 space-y-5">
        {summary && (
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="legal-summary-kpis">
            {[["Documentos", summary.documentos], ["Vigentes", summary.vigentes],
              ["Por vencer (30d)", summary.por_vencer_30d], ["Vencidos", summary.vencidos],
              ["Representantes", summary.representantes_vigentes]].map(([l, v]) => (
              <div key={l} className="panel p-3">
                <div className="label-mono text-[10px]">{l}</div>
                <div className={`font-mono text-lg font-bold ${l === "Vencidos" && v > 0 ? "text-red-400" : l.startsWith("Por vencer") && v > 0 ? "text-amber-400" : "text-cyan-300"}`}>{v}</div>
              </div>
            ))}
          </div>
        )}
        <div className="flex gap-1 flex-wrap border-b pb-2" style={{ borderColor: "var(--border)" }}>
          {TABS.map((t) => (
            <button key={t.id} data-testid={`legal-tab-${t.id}`} onClick={() => setTab(t.id)}
              className={`px-3 py-1.5 text-xs uppercase tracking-widest rounded-sm ${tab === t.id ? "btn-primary" : "btn-ghost"}`}>
              {t.label}
            </button>
          ))}
        </div>
        {tab === "perfil" && <CorporateProfile />}
        {tab === "representantes" && <Representatives onMutate={loadSummary} />}
        {tab === "documentos" && <CorporateDocuments onMutate={loadSummary} />}
        {tab === "oficios" && <Oficios />}
        {tab === "membretes" && <Letterheads />}
        {tab === "plantillas" && <RequirementTemplates />}
      </div>
    </div>
  );
}
